import { render, staticRenderFns } from "./CultureViImageType.vue?vue&type=template&id=10181a7a&scoped=true&"
import script from "./CultureViImageType.vue?vue&type=script&lang=js&"
export * from "./CultureViImageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10181a7a",
  null
  
)

export default component.exports